<template>
  <div class="cpt-chat-more-loading flex-center h-[50px] w-full relative">
    <div class="loading w-[12px] h-[12px]"></div>
  </div>
</template>

<script>
export default {
  name: 'ChatMoreLoading'
}
</script>
<style lang="scss">
.cpt-chat-more-loading {
  .loading {
    background-image: url(https://imgheybox.max-c.com/oa/2022/02/16/34a1a6bd20c5f87e8e80defa72e3ac47.png);
    background-position: 0 0;
    background-size: 7600%;
    animation: loading-frames 2.533s steps(75) infinite;
    transform: translate3d(0, 0, 0);
  }
}

@keyframes loading-frames {
  from {
    background-position: left;
  }

  to {
    background-position: right;
  }
}
</style>